import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { Button, Toastr, Loader } from "arv-reactcomponents";
import SizeBlock from "../../ProductList/SizeBlock";

import { getKeyFromDecodedToken } from "../../../utils";
import { RETURNS } from "npmlinks-constants";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";

const { EXCHANGE_INITIATE } = RETURNS;

@inject("LoginStore", "ReturnStore", "ProductStore")
@observer
class ExchangeInitiate extends Component {
  static renderLoader() {
    return (
      <div className="nw-bodyoverlay nw-exchangeinitiate-loader">
        <div className="nw-bodyoverlay-loadercontainer">
          <Loader />
        </div>
      </div>
    );
  }

  constructor(props) {
    super(props);

    this.state = {
      userName: "",
      email: "",
      availableSizes: [],
      selectSelectedValue: "",
      isLoaded: false,
      selectedSize: "",
    };

    this.init = this.init.bind(this);
    this.updateUserData = this.updateUserData.bind(this);
    this.updateSizeAndSelectedValue = this.updateSizeAndSelectedValue.bind(
      this,
    );
    this.updateSelectedSize = this.updateSelectedSize.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.init();
  }
    
  init() {
    this.updateUserData();
    this.updateSizeAndSelectedValue();
     const { sizeChartId, ProductStore } = this.props;

     if (sizeChartId) {
      ProductStore.getFitGuideDtails(sizeChartId);
     }
  }

  updateUserData() {
    const { isUserLoggedIn } = this.props.LoginStore;
    if (isUserLoggedIn) {
      const userData = getKeyFromDecodedToken();
      const { firstName = "", email_id = "" } = userData;
      this.setState({
        userName: firstName,
        email: email_id,
      });
    }
  }

  updateSizeAndSelectedValue() {
    const { sizeDetails } = this.props;
    this.setState({
      availableSizes: sizeDetails,
    });
  }

  updateSelectedSize(selectedValue) {
    this.setState({
      selectSelectedValue: selectedValue.skuId,
      selectedSize: selectedValue.size,
    });
  }

  get requestBody() {
    const { orderId, consignmentId, productData } = this.props;
    const { styleId, skuId } = productData;
    return {
      orderId,
      consignmentId,
      styleId,
      ean: skuId,
    };
  }

  handleSubmit(e) {
    e.preventDefault();
    const { email, selectedSize } = this.state;

    this.setState({
      isLoaded: !this.state.isLoaded,
    });

    Analytics.trackEvent({
      category: Event.category.ORDER_DETAIL,
      action: Event.action.EXCHANGE_SIZE_SUBMIT,
    });

    this.props.ReturnStore.makeExchange(
      this.requestBody,
      email,
      selectedSize,
    )
      .then(() => {
        this.setState({
          isLoaded: !this.state.isLoaded,
        });
        this.props.exchangeStatus(true);
      })
      .catch(() => {
        this.setState({
          isLoaded: !this.state.isLoaded,
        });
        Toastr.showToastr({
          className: "nwc-toastr-list-danger nw-toastr",
          message: EXCHANGE_INITIATE.ERROR_MESSAGE,
          timeout: 3000,
        });
      });
  }

  get userNameBlock() {
    const { userName } = this.state;
    return (
      <p className="nw-exchangeinitiate-userblock">{`${EXCHANGE_INITIATE.USERBLOCK} ${userName},`}</p>
    );
  }

  get buttonState() {
    const { selectSelectedValue } = this.state;
    return selectSelectedValue.length > 0;
  }

  get sizeInputComponent() {
    const { availableSizes, selectSelectedValue } = this.state;
    const { tenantSizeLabel, sizeMappingEnabled } = this.props;
    return (
      <form className="nw-exchangeinitiate-form" onSubmit={this.handleSubmit}>
        <div className="nw-exchangeinitiate-sizedetails">
          <SizeBlock.component
            selectedSkuId={selectSelectedValue}
            selectSku={this.updateSelectedSize}
            skus={availableSizes}
            ProductLoader={false}
            tenantSizeLabel={tenantSizeLabel}
            sizeMappingEnabled={sizeMappingEnabled}
          />
        </div>
        <Button
          className="nwc-btn-primary nw-exchangeinitiate-button"
          type="submit"
          onClick={this.handleSubmit}
          disabled={!this.buttonState}
        >
          {EXCHANGE_INITIATE.BUTTONTEXT}
        </Button>
      </form>
    );
  }

  get sizeText() {
    const { tenantSizeLabel } = this.props;
    return  tenantSizeLabel || EXCHANGE_INITIATE.SIZEBLOCK1;
  }

  render() {
    const { isLoaded } = this.state;
    return (
      <div className="nw-exchangeinitiate-block">
        {isLoaded && ExchangeInitiate.renderLoader()}
        <h3 className="nw-exchangeinitiate-title">{EXCHANGE_INITIATE.TITLE}</h3>
        {this.userNameBlock}
        <p className="nw-exchangeinitiate-msgblock">{EXCHANGE_INITIATE.MSG}</p>
        <p className="nw-exchangeinitiate-sizeblock nw-exchangeinitiate-msgblock">
          {EXCHANGE_INITIATE.SIZEBLOCK0}
          <span className="nw-exchangeinitiate-size">
            {this.sizeText}
          </span>
          {EXCHANGE_INITIATE.SIZEBLOCK2}
        </p>
        {this.sizeInputComponent}
      </div>
    );
  }
}

ExchangeInitiate.defaultProps ={
  sizeMappingEnabled: false
}

ExchangeInitiate.propTypes = {
  LoginStore: PropTypes.shape({
    isUserLoggedIn: PropTypes.bool.isRequired,
  }).isRequired,
  ReturnStore: PropTypes.shape({
    makeExchange: PropTypes.func.isRequired,
  }).isRequired,
  productData: PropTypes.shape({
    size: PropTypes.string.isRequired,
  }).isRequired,
  consignmentId: PropTypes.string.isRequired,
  orderId: PropTypes.string.isRequired,
  exchangeStatus: PropTypes.func.isRequired,
  sizeDetails: PropTypes.shape({}).isRequired,
  tenantSizeLabel: PropTypes.string.isRequired,
  sizeMappingEnabled: PropTypes.bool.isRequired,
  ProductStore: PropTypes.shape({
    sizeChartData: PropTypes.shape({}),
  }).isRequired,
};

const getFinalComponent = component =>
  inject("LoginStore", "ReturnStore", "ProductStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: ExchangeInitiate.wrappedComponent,
  component: ExchangeInitiate,
};

export default ProjectComponent;
